import type { TFunction } from "i18next";
import type { Schema } from "@/shared/components/Form/types";
import { ArrayItemRow } from "@/shared/components/Form";

export function makePlatformSocialSchema(t: TFunction): Schema {
  return {
    "footer.social": {
      type: "array",
      addText: t("platformSocial.form.addLink"),
      xs: 12,
      fullWidth: true,
      itemComponent: ArrayItemRow,
      subschema: {
        type: {
          type: "select",
          label: t("platformSocial.form.typeLabel"),
          xs: 12,
          sm: 6,
          fullWidth: true,
          required: true,
          // Названия соцсетей — бренды, не переводятся.
          options: [
            { value: "facebook", label: "Facebook" },
            { value: "twitter", label: "Twitter X" },
            { value: "youtube", label: "Youtube" },
            { value: "instagram", label: "Instagram" },
            { value: "telegram", label: "Telegram" },
            { value: "tiktok", label: "Tiktok" },
          ],
        },
        link: {
          type: "text",
          label: t("platformSocial.form.linkLabel"),
          xs: 12,
          sm: 6,
          fullWidth: true,
          required: true,
          placeholder: "https://example.com",
        },
      },
    },
  };
}
